<template>
    <v-container id="listadoxperiodociclolectivoycurso-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>REPORTE DE CURSADA - SECUNDARIO - POR PERIODO, CICLO LECTIVO Y CURSO</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="4" lg="4">
                  <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-select
                    v-model="filtros.idperiodo"
                    :items="listatemporalidadinformes.filter(t=> t.idtipotemporalidad===2)"
                    label="Periodo"
                    item-text="descripcion"
                    item-value="idperiodo"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-select
                    v-model="filtros.iddivision"
                    :items="listadivisiones"
                    label="División"
                    item-text="nombre"
                    item-value="iddivision"
                    height="20px"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.idreporte"
                    :items="listareportes"
                    label="Reporte"
                    item-text="reporte"
                    item-value="idreporte"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.formato"
                    :items="listaformatos"
                    label="Formato"
                    item-text="formato"
                    item-value="formato"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="6" lg="6" class="alineaderecha">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="success"
                    title="Imprimir"
                    @click="ImprimirListado"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../../Confirm.vue";
export default {
  name: "listadoxperiodociclolectivoycurso",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 29,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      menufecha: false,
      filtros: {
        anio: 0,
        idperiodo: 0,
        iddivision: 0,
        idreporte: 0,
        formato: 'PDF'
      },
      listaanios: [],
      listatemporalidadinformes: [],
      listadivisiones: [],
      listaformatos: [
        {formato: 'PDF'},
        {formato: 'EXCEL'},
      ],
      listareportes: [{idreporte: 26, reporte: 'Informe por Estudiante'},
                      {idreporte: 27, reporte: 'Informe por Asignatura'},
                      {idreporte: 28, reporte: 'Informe para VxV'}]
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        var i=0;
        var anioactual= (new Date()).getFullYear();
        for(i=2026;i<=anioactual+1;i++){
          this.listaanios.push({anio: i});
        }
        this.filtros.anio= anioactual;
        this.filtros.idreporte= this.listareportes[0].idreporte;
        axios.post('secundario/PostListaTiposTemporalidadesyPeriodos', { headers: { "Content-Type": "application/json"}}).then((result) => {
        if(result.data.resultado===0){
          this.listatemporalidadinformes = result.data.datos[1];
          this.filtros.idperiodo=11;
          var parametros= JSON.stringify({usuario: this.usuario, anio: this.filtros.anio, idasignatura: 0});
          axios.post("secundario/PostDivisionesXUsuarioAnioAsignatura",parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
            if(result.data.resultado===0){
              this.listadivisiones = result.data.datos;
              if(this.listadivisiones.length>0) {
                this.filtros.iddivision= this.listadivisiones[0].iddivision;
              }
              this.loading= false;
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    ImprimirListado () {
      this.loading = true;
      axios.post("reportes/GetReporte",
        {idreporte: this.filtros.idreporte, formato: this.filtros.formato,nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idperiodo", valor: this.filtros.idperiodo.toString()}, { orden: 2, nombre: "ciclolectivo", valor: this.filtros.anio.toString()}, { orden: 3, nombre: "iddivision", valor: this.filtros.iddivision.toString()},{ orden: 4, nombre: "usuario", valor: this.usuario} ] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    }
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.fullpantalla{
    height: 100% !important;
    width: 100% !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>